document.addEventListener('DOMContentLoaded', () => {
  console.log('product.js: Initializing...');

  const productForm = document.querySelector('.main-product__form');
  const addButton = document.querySelector('[data-add-to-cart]');
  const variantInput = document.querySelector('[data-variant-input]');
  const product = window.product;

  if (!productForm || !addButton || !variantInput || !product) {
    console.error('product.js: Missing required elements');
    return;
  }

  // MARK: Prevent global AddToCart.js from interfering
  productForm.dataset.skipGlobalCart = 'true';

  let selectedColor = null;
  let selectedSize = null;

  function findVariant(color, size) {
    return product.variants.find(v => v.option1 === color && v.option2 === size);
  }

  function updateUI(variant) {
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare-price]');
    const saleTag = document.querySelector('.main-product__sale-tag');
    const priceContainer = document.querySelector('.main-product__price');

    if (priceEl) priceEl.textContent = (variant.price / 100).toFixed(2);

    const hasSale = variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.textContent = hasSale ? (variant.compare_at_price / 100).toFixed(2) : '';
      compareEl.style.display = hasSale ? 'inline' : 'none';
    }
    if (saleTag) saleTag.style.display = hasSale ? 'inline' : 'none';
    if (priceContainer) priceContainer.classList.toggle('has-sale', hasSale);

    variantInput.value = variant.id;
    addButton.disabled = !variant.available;
    addButton.classList.toggle('is-disabled', !variant.available);
    addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
  }

  function highlight(variant) {
    document.querySelectorAll('.main-product__swatch').forEach(s => {
      s.classList.toggle('is-selected', s.dataset.color === variant.option1);
    });
    document.querySelectorAll('.main-product__size-button').forEach(b => {
      b.classList.toggle('is-selected', b.dataset.size === variant.option2);
    });
  }

  // Swatches
  document.querySelectorAll('.main-product__swatch').forEach(s => {
    s.addEventListener('click', () => {
      selectedColor = s.dataset.color;
      if (!selectedSize) {
        const v = product.variants.find(v => v.option1 === selectedColor);
        selectedSize = v?.option2;
      }
      const variant = findVariant(selectedColor, selectedSize);
      if (variant) { updateUI(variant); highlight(variant); }
    });
  });

  // Sizes
  document.querySelectorAll('.main-product__size-button').forEach(b => {
    b.addEventListener('click', () => {
      selectedSize = b.dataset.size;
      if (!selectedColor) {
        const v = product.variants.find(v => v.option2 === selectedSize);
        selectedColor = v?.option1;
      }
      const variant = findVariant(selectedColor, selectedSize);
      if (variant) { updateUI(variant); highlight(variant); }
    });
  });

  // ADD TO CART – ONE REQUEST ONLY
  productForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('product.js: Form submit blocked – handling via JS');

    const id = variantInput.value;
    if (!id) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: 1 })
      });

      if (!res.ok) throw new Error('Failed');

      // Notify simple-cart.js
      document.dispatchEvent(new CustomEvent('product:added', {
        detail: { item: { variant_id: parseInt(id), quantity: 1 } }
      }));

      if (window.cartManager) {
        await window.cartManager.loadCartData(true);
      }

      // Open drawer
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('openDrawer', {
          detail: { drawerId: 'cart', position: 'right' }
        }));
      }, 100);

      addButton.textContent = 'Added!';
      setTimeout(() => {
        addButton.disabled = false;
        addButton.textContent = 'Add to bag';
      }, 1000);

    } catch (err) {
      console.error(err);
      addButton.textContent = 'Error';
      setTimeout(() => {
        addButton.disabled = false;
        addButton.textContent = 'Add to bag';
      }, 1500);
    }
  });

  // Init
  const init = product.selected_or_first_available_variant || product.variants[0];
  selectedColor = init.option1;
  selectedSize = init.option2;
  updateUI(init);
  highlight(init);

  console.log('product.js: Ready');
});